import { render, staticRenderFns } from "./BranchTable.vue?vue&type=template&id=c53e15ac&scoped=true&"
import script from "./BranchTable.vue?vue&type=script&lang=js&"
export * from "./BranchTable.vue?vue&type=script&lang=js&"
import style0 from "./BranchTable.vue?vue&type=style&index=0&id=c53e15ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53e15ac",
  null
  
)

export default component.exports